import {graphql} from 'react-apollo';
import {updateStayMutation} from '../../graphql';

const withUpdateStayOnTripBoard = graphql(updateStayMutation, {
    options: (props) => ({...props.mutationConfig}),
    name: 'updateStayOnTripBoard',
    alias: 'withUpdateStayMutation'
});

export default withUpdateStayOnTripBoard;
